<!-- 배치전 / 배치후 / 특수 -->
<template>
  <div class="print-container">
    <div class="flex items-center justify-between mb-5">
      <h5 class="flex items-center"><i class="dot"></i>{{ title }}</h5>
      <div v-if="!readonly && !isPrint" class="flex items-center gap-2">
        <vs-button color="secondary" type="flat" @click="fold = false"><img src="@/assets/images/icon/IconTriangleDown.svg" class="inline-block align-middle" /> 모두펼치기</vs-button>
        <hr class="-mx-2" style="height: 20px; border-width: 1px; border-color: #6670cb; border-left: 0" />
        <vs-button color="secondary" type="flat" @click="fold = true"> <img src="@/assets/images/icon/IconTriangleDown.svg" class="inline-block align-middle" style="transform: rotate(180deg)" /> 모두접기</vs-button>
        <vs-button color="secondary" type="border" @click="handleAddRow"> 항목추가 </vs-button>
        <vs-button color="secondary" @click="handleRemoveRow" :disabled="checkData.length === 0"> 선택삭제 </vs-button>
      </div>
    </div>
    <div v-show="!fold" v-for="(item, index) in list" :key="item.id" class="content-container mt-5">
      <div v-if="!readonly && !isPrint" class="checkbox-container z-10">
        <vs-checkbox :vs-value="item.id" v-model="checkData" class="checkbox" />
      </div>
      <div>
        <table>
          <colgroup></colgroup>
          <tr>
            <th>검진일<br />/ 검진병원</th>
            <th>특수건강진단 건강관리구분 판정</th>
            <th>검진소견</th>
            <th>사후관리조치</th>
            <th>업무적합성 평가</th>
          </tr>
          <tr>
            <td>
              <p v-if="isPrint" class="print-input mb-2">{{ item["검진일"] }}</p>
              <date-selector v-else :readonly="readonly" v-model="item['검진일']" placeholder="날짜" class="w-full mb-2"></date-selector>
              <p v-if="isPrint" class="print-input">{{ item["검진병원"] }}</p>
              <ml-input v-else :readonly="readonly" v-model="item['검진병원']" class="w-full" />
            </td>
            <td>
              <p v-if="isPrint" class="print-input">{{ item["판정"] }}</p>
              <!-- <vs-select v-else :disabled="readonly" v-model="item['판정']" autocomplete class="w-full flex-1">
                <vs-select-item v-for="option of determinationOptions" :text="option" :value="option" :key="option" />
              </vs-select> -->
              <multiselect v-else :readonly="readonly" :options="determinationOptions" v-model="item['판정']" :multiple="true" placeholder="" class="w-full" />
            </td>
            <td>
              <p v-if="isPrint" class="print-textarea">{{ item["검진소견"] }}</p>
              <ml-textarea v-else :readonly="readonly" v-model="item['검진소견']" class="w-full h-full" height="100%" />
            </td>
            <td>
              <p v-if="isPrint" class="print-textarea">{{ item["사후관리조치"] ? item["사후관리조치"].toString() : "" }}</p>
              <multiselect v-else :readonly="readonly" :options="optionManagement" v-model="item['사후관리조치']" :multiple="true" placeholder="" class="w-full" />
            </td>
            <td>
              <p v-if="isPrint" class="print-input">{{ item["업무적합성평가"] ? item["업무적합성평가"].join(", ") : "" }}</p>
              <multiselect v-else :readonly="readonly" :options="['가', '나', '다', '라']" v-model="item['업무적합성평가']" :multiple="true" placeholder="" class="w-full" />
            </td>
          </tr>
          <tr>
            <td colspan="5">
              <div class="flex items-center justify-end">
                <p style="font-size: 16px; font-weight: 500" class="flex-1">검사결과</p>
                <vs-button v-if="!isPrint" color="secondary" type="flat" @click="() => addResult(index)"><img src="@/assets/images/icon/icon-plus.svg" class="inline-block align-middle" /> 항목 추가</vs-button>
                <hr v-if="!isPrint" style="height: 20px; border-width: 1px; border-color: #6670cb; border-left: 0" />
                <vs-button v-if="!isPrint" color="secondary" type="flat" @click="() => removeResult(index)">
                  <img src="@/assets/images/icon/icon-minus.svg" class="inline-block align-middle" style="transform: rotate(180deg)" /> 마지막 항목 삭제
                </vs-button>
              </div>
            </td>
          </tr>
          <tr>
            <th>구분</th>
            <th colspan="4">검사결과</th>
          </tr>
          <tr v-for="(rs, rs_i) in item['검사결과']" :key="`검사결과_${rs_i}`">
            <td>
              <p v-if="isPrint" class="print-input">{{ rs["구분"] ? rs["구분"].join(", ") : "" }}</p>
              <multiselect
                v-else
                :readonly="readonly"
                :options="['이비인후계', '순환기계', '호흡기계', '비뇨기계', '간담도계', '조혈기계', '기타']"
                v-model="rs['구분']"
                :multiple="true"
                :maxHeight="160"
                placeholder=""
                class="w-full"
                :class="item['검사결과'].length === rs_i + 1 && 'last-rs'"
              />
            </td>
            <td colspan="4">
              <p v-if="isPrint" class="print-textarea">{{ rs["검사결과"] }}</p>
              <ml-textarea v-else :readonly="readonly" v-model="rs['검사결과']" class="w-full h-full" />
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import DateSelector from "@/components/selector/DateSelector";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  components: {
    Multiselect,
    DateSelector,
    TimeSelector,
    PrintCheckbox,
  },
  props: {
    title: String,
    value: Array,
    readonly: {
      type: Boolean,
      default: false,
    },
    isPrint: {
      type: Boolean,
      default: false,
    },
    determinationOptions: {
      type: Array,
      default: () => ["C2", "D2"],
    },
  },
  data() {
    return {
      fold: false,
      checkData: [],
      list: this.value,
      optionManagement: ["필요없음", "건강상담", "보호구지급 및 착용지도", "추적검사", "근무중 치료", "근로시간 단축", "작업전환", "근로제한 및 금지", "직업병 확진의뢰 안내", "기타"],
    };
  },
  watch: {
    value: {
      handler(value) {
        this.list = value;
      },
    },
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    // 항목추가
    handleAddRow() {
      const addData = { id: this.generateRandomId(), 검사결과: [] };
      this.list.unshift(addData);
    },
    // 선택삭제
    handleRemoveRow() {
      this.list = this.list.filter((item) => !this.checkData.includes(item.id));
      this.checkData = [];
    },

    // 검사결과를 추가한다.
    addResult(index) {
      const addData = { 구분: "", 검사결과: "" };
      this.list[index]["검사결과"].push(addData);
    },
    // 검사결과중 가장 마지막 항목을 삭제한다.
    removeResult(index) {
      this.list[index]["검사결과"].pop();
    },
    generateRandomId() {
      return Math.random().toString(36).substr(2, 9);
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox::v-deep {
  justify-content: center !important;
  span {
    margin: 0px !important;
  }
}
.content-container {
  display: flex;
  table:nth-child(n + 2) {
    margin-top: -1px;
  }
}

.checkbox-container {
  width: 36px;

  display: flex;
  justify-content: center;

  background: #f9f9f9;
  border: 1px solid #cdcdcd;
}
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  margin-left: -1px;

  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    background: #f9f9f9;
    padding: 18px 0px;
  }

  td {
    height: 1px;
    vertical-align: top;
    padding: 7px;

    ul {
      width: 100%;
      height: 100%;

      display: flex;
      flex-direction: column;
      justify-content: space-between;

      li {
        flex: 1;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #cdcdcd;
        p {
          flex: 1;
          padding: 7px;
        }

        & > div {
          height: 100%;
          display: flex;
          align-items: center;
          justify-items: center;
          border-left: 1px solid #cdcdcd;
          padding: 7px;
        }

        &:last-child {
          border-bottom: 0px;
        }
      }
    }
  }
}

.last-rs::v-deep .multiselect__content-wrapper {
  top: -160px;
  border: 1px solid #e8e8e8;
  border-bottom: none;
  border-radius: 5px 5px 0px 0px !important;
}
</style>
